// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3bMy0","header":"Messages_header__2RaBI"};